import React from 'react'
import { HiOutlineMenuAlt2, HiOutlineX } from 'react-icons/hi';

const MenuButton = ({ visible, setVisible }) => {
    const menuHandler = () => {
        setVisible(!visible);
    }

    return (
        <>
            <button className='bg-white/50 dark:bg-gray-800/50 text-skin-base p-3 rounded-custom fixed top-3 left-3 backdrop-blur-md block md:hidden' onClick={menuHandler} style={{ zIndex: "30" }}
            >
                {
                    visible ? <HiOutlineMenuAlt2 className='h-8 w-8' /> : <HiOutlineX className='h-8 w-8' />
                }
            </button>
        </>
    )
}

export default MenuButton